import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { DEFAULT_TIMEOUT, InterceptorService } from "./interceptor.service";

export const httpInterceptorProviders=[
  {provide:HTTP_INTERCEPTORS,useClass:InterceptorService,multi:true},
  {provide:DEFAULT_TIMEOUT,useValue:30000}
]
